<template>
    <dialog-generic :visibility.sync = 'visibility' :indicator = 'indicator' :max-width = '$vuetify.breakpoint.smAndUp ? "50%": "95%"'>
        <template v-slot:title>{{details.formal_name}}</template>
        <template v-slot:content>
            <v-layout column class = 'text-start'>
                <span class = 'subheading text-center my-1 font-weight-light'><span class = 'font-weight-regular'>{{details.project_name}}</span> | Данные для экспорта в BigQuery</span>
                <v-flex d-flex row justify-space-between align-center my-1 ml-1>
                    <span class = 'body-2'>Проект</span>
                    <v-text-field 
                        outlined single-line readonly hide-details 
                        value = 'trying-artics-pipeline'
                        style = 'color: black !important; max-width: 50%;'
                    >
                        <template slot = 'append'>
                            <v-btn icon small @click = '$copyText("trying-artics-pipeline")' class = 'mx-0 px-0'>
                                <v-icon small :color = '$store.getters.uiAccent'>mdi-content-copy</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </v-flex>
                <v-flex d-flex row justify-space-between align-center my-1 ml-1>
                    <span class = 'body-2'>Набор данных</span>
                        <v-text-field 
                            outlined single-line readonly hide-details 
                            :value = 'details.dataset_name'
                            style = 'color: black !important; max-width: 50%;'
                        >
                            <template slot = 'append'>
                                <v-btn small icon @click = '$copyText(details.dataset_name)' class = 'mx-0 px-0'>
                                    <v-icon small :color = '$store.getters.uiAccent'>mdi-content-copy</v-icon>
                                </v-btn>
                            </template>
                        </v-text-field>
                </v-flex>
                <v-flex d-flex row justify-space-between align-center my-1 ml-1>
                    <span class = 'body-2'>Хвостик таблицы</span>
                    <v-text-field 
                        outlined single-line readonly hide-details 
                        :value = '`${details.project_table}_{startYYYY}_{startMM}`'
                        style = 'color: black !important; max-width: 50%;'
                    >
                        <template slot = 'append'>
                            <v-btn icon small @click.stop = 'copyTextToClipboard(`${details.project_table}_{startYYYY}_{startMM}`)' class = 'mx-0 px-0'>
                                <v-icon small :color = '$store.getters.uiAccent'>mdi-content-copy</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </v-flex>
            </v-layout>
        </template>
    </dialog-generic>
</template>

<style>
    .v-input__append-inner {
        margin: auto !important;
    }
</style>

<script>

    import DialogGeneric from '@/components/elements/dialogs/Generic.vue'
    import projectHandlers from '@/mixins/project'

    export default {
        name: 'ConnectionDetails',
        mixins: [projectHandlers],
        props: ['initialState', 'data'],
        components: {'dialog-generic': DialogGeneric},
        data() {
            return {
                visibility: this.initialState,
                project: this.data,
                indicator: false,
                indicatorSecondary: false,
                details: {},
                state: []
            }
        },
        watch: {
            initialState(value) {
                this.visibility = value
            },
            visibility(value) {
                this.$emit('update:initialState', value);
                if (value) {
                    this.getProjectConnectionDetails()
                }
            },
            data(value) {
                this.project = value
                this.getProjectConnectionDetails()
            }
        },
        methods: {
            copyTextToClipboard(text) {
                console.log('copy operation emitted');
                this.$copyText(text).then((r) => {
                    console.log('copy operation complete')
                }, (e) => {
                    console.log('copy operation failed');
                })
            },
            getProjectState() {
                this.indicatorSecondary = true;
                this.getProjectPropertyPromise('state').then((r) => {
                    let response = r.body
                    this.indicatorSecondary = false
                    if (response.result) {
                        this.state = response.data
                    } else {
                        console.log('error fetch project state', response.data)
                    }
                });
            },
            getProjectConnectionDetails() {
                this.indicator = true;
                //this.getProjectState()
                this.getProjectPropertyPromise('connection').then((r) => {
                    let response = r.body
                    this.indicator = false
                    if (response.result) {
                        this.details = response.data
                    } else {
                        console.log('error fetch project connection', response.data)
                    }
                });
            }
        }
    }
</script>